module.exports = __webpack_public_path__ + "static/RockwalletHome-e5e47d85cff84c08e21e502e2fa86732.png";